import FieldWrapper, {GenericCheckbox, GenericDropdown, GenericRadio} from "../FieldWrapper";
import {SettingEnum, SettingPrefixEnum} from "../settingEnum";
import {LabelEnum} from "../../LabelEnum";
import {
  deviceTransactionLogs,
  userTransactionLogs,
  devicePositionHistoryDepthHours,
  devicePositionHistoryDepthPosPlots,
  userInactivityLimitOptions,
  nokEmployeeLoginIdleHour
} from "./options";
import { time } from "@Elements/Form/utils";
// Dropdowns
export const DeviceTransactionLogs = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {
      units: time.days,
      unitsMargin: '250px'
    }
  },
  prefix: SettingPrefixEnum.OTHER_SETTING,
  policyPrefix: SettingPrefixEnum.PRIVACY,
  field: SettingEnum.DEVICE_TRANSACTION_LOGS,
  title: LabelEnum.DEVICE_TRANSACTION_LOGS_LABEL,
  dataOptions: {
    options: deviceTransactionLogs,
    skipMap: true
  },
  tooltip: LabelEnum.DEVICE_TRANSACTION_LOGS_TOOLTIP

});

export const UserTransactionLogs = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {
      units: time.days,
      unitsMargin: '250px'
    }
  },
  prefix: SettingPrefixEnum.OTHER_SETTING,
  policyPrefix: SettingPrefixEnum.PRIVACY,
  field: SettingEnum.USER_TRANSACTION_LOGS,
  title: LabelEnum.USER_TRANSACTION_LOGS_LABEL,
  dataOptions: {
    options: userTransactionLogs,
    skipMap: true
  },
  tooltip: LabelEnum.USER_TRANSACTION_LOGS_TOOLTIP

});


export const DevicePositionHistoryDepthHours = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {
      units: time.hour,
      unitsMargin: '250px'
    }
  },
  prefix: SettingPrefixEnum.OTHER_SETTING,
  policyPrefix: SettingPrefixEnum.PRIVACY,
  field: SettingEnum.DEVICE_POSITION_HISTORY_DEPTH_HOURS,
  title: LabelEnum.DEVICE_POSITION_HISTORY_DEPTH_HOURS_LABEL,
  dataOptions: {
    options: devicePositionHistoryDepthHours,
    skipMap: true
  },
  tooltip: LabelEnum.DEVICE_POSITION_HISTORY_DEPTH_HOURS_TOOLTIP
});

export const DevicePositionHistoryDepthPosPlots = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {
      units: { id: 'dropdownPositions', defaultMessage: 'positions' },
      unitsMargin: '250px'
    }
  },
  prefix: SettingPrefixEnum.OTHER_SETTING,
  policyPrefix: SettingPrefixEnum.PRIVACY,
  field: SettingEnum.DEVICE_POSITION_HISTORY_DEPTH_POS_PLOTS,
  title: LabelEnum.DEVICE_POSITION_HISTORY_DEPTH_POS_PLOTS_LABEL,
  dataOptions: {
    options: devicePositionHistoryDepthPosPlots,
    skipMap: true
  },
  tooltip: LabelEnum.DEVICE_POSITION_HISTORY_DEPTH_POS_PLOTS_TOOLTIP
});

export const NokEmployeeLoginIdleHour = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {
      units: time.hour,
      unitsMargin: '250px'
    }
  },
  prefix: SettingPrefixEnum.OTHER_SETTING,
  policyPrefix: SettingPrefixEnum.PRIVACY,
  field: SettingEnum.NOK_EMPLOYEE_LOGIN_IDLE_HOUR,
  title: LabelEnum.NOK_EMPLOYEE_LOGIN_IDLE_HOUR_LABEL,
  dataOptions: {
    options: nokEmployeeLoginIdleHour,
    skipMap: true,
    translate: true
  },
  tooltip: LabelEnum.NOK_EMPLOYEE_LOGIN_IDLE_HOUR_TOOLTIP
});

export const UserInactivityLimit = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {

    }
  },
  prefix: SettingPrefixEnum.OTHER_SETTING,
  policyPrefix: SettingPrefixEnum.PRIVACY,
  field: SettingEnum.USER_INACTIVITY_LIMIT,
  title: LabelEnum.USER_INACTIVITY_LIMIT,
  dataOptions: {
    options: userInactivityLimitOptions,
    skipMap: true,
    translate: true
  },
  tooltip: LabelEnum.USER_INACTIVITY_LIMIT_TOOLTIP
});

export const AnonymizeNotifcation = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: true,
      label: {id: "anonymizeNotifcation", defaultMessage: "Anonyme notifikasjoner"},
      tooltip: LabelEnum.ANONYMIZE_NOTIFICATION_TOOLTIP,
    }
  },
  prefix: SettingPrefixEnum.OTHER_SETTING,
  policyPrefix: SettingPrefixEnum.PRIVACY,
  field: SettingEnum.ANONYMIZE_NOTIFICATION,

});


export const NokIDLogin = FieldWrapper({
  componentOptions: {
    Component: GenericRadio,
    props: {
      modal: true,
      confirmValue: "2",
      modalHeader: { id: LabelEnum.NOK_ID_LOGIN_HEADER_CONFIRM, defaultMessage: "Confirm change" },
      modalText: { id: LabelEnum.NOK_ID_LOGIN_TEXT_CONFIRM, defaultMessage: "Are you sure you want to change this setting?" },
      modalOkText: { id: "confirm", defaultMessage: "Confirm" },
      modalCancelText: { id: "cancel", defaultMessage: "Avbryt" }
    }
  },
  title: LabelEnum.NOK_ID_LOGIN_HEADER,
  tooltip: LabelEnum.NOK_ID_LOGIN_TOOLTIP,
  prefix: SettingPrefixEnum.OTHER_SETTING,
  policyPrefix: SettingPrefixEnum.PRIVACY,
  field: SettingEnum.NOK_NATIONAL_ID,
  hideField: SettingEnum.NEXT_OF_KIN_AUTH_TYPE,
  textSuffixField: SettingEnum.NEXT_OF_KIN_AUTH_TYPE,
  hideFieldValue: "P",
  borderBottom: true,
  dataOptions: {
    options: [
      { value: "1", text: LabelEnum.NOK_ID_LOGIN_TEXT_OPTIONAL, description: LabelEnum.NOK_ID_LOGIN_DESC_OPTIONAL },
      { value: "2", text: LabelEnum.NOK_ID_LOGIN_TEXT_MANDATORY, description: LabelEnum.NOK_ID_LOGIN_DESC_MANDATORY },
    ],
    translate: true,
    skipMap: true,
  },
});
